import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import EditorPage from "./pages/EditorPage";
import AboutPage from "./pages/AboutPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";
import CollagePage from "./pages/CollagePage";
import TutorialPage from "./pages/TutorialPage";
import GuidesIndexPage from "./pages/GuidesIndexPage";
import GuidePage from "./pages/GuidePage";
import StoryboardLandingPage from "./pages/StoryboardLandingPage";
import StoryboardTemplatesIndexPage from "./pages/StoryboardTemplatesIndexPage";
import StoryboardTemplatePage from "./pages/StoryboardTemplatePage";
import { trackPageView } from "./utils/analytics";
import { applyPageMeta } from "./utils/pageMeta";

function RouteTracker() {
  const location = useLocation();
  useEffect(() => {
    const title = applyPageMeta(location.pathname);
    trackPageView(location.pathname + location.search, title);
  }, [location]);
  return null;
}

// Exported for testing with MemoryRouter
export function AppRoutes() {
  return (
    <>
      <RouteTracker />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/editor" element={<EditorPage />} />
        <Route path="/storyboard/editor" element={<EditorPage kind="storyboard" />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/collage" element={<CollagePage />} />
        <Route path="/tutorial" element={<TutorialPage />} />
        <Route path="/guides" element={<GuidesIndexPage />} />
        <Route path="/guides/:slug" element={<GuidePage />} />
        <Route path="/storyboard" element={<StoryboardLandingPage />} />
        <Route path="/storyboard-templates" element={<StoryboardTemplatesIndexPage />} />
        <Route path="/storyboard-templates/:slug" element={<StoryboardTemplatePage />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
